import React, {useContext} from "react";
import {ReactComponent as DictionariesIcon} from "../../../statics/icons/icon_dictionaries.svg";
import {ReactComponent as CalendarIcon} from "../../../statics/icons/icon_calendar.svg";
import {ReactComponent as AdministrateIcon} from "../../../statics/icons/icon_administrate.svg";
import {ReactComponent as TicketIcon} from "../../../statics/icons/icon_ticket.svg";
import {ReactComponent as OrderIcon} from "../../../statics/icons/icon_list.svg";
import {ReactComponent as TopologyIcon} from "../../../statics/icons/icon_place.svg";
import {ReactComponent as DocumentsIcon} from "../../../statics/icons/icon_documents.svg";
import {ReactComponent as AlertsIcon} from "../../../statics/icons/icon_notify.svg";
import {ReactComponent as LocationIcon} from "../../../statics/icons/icon_location.svg";
import {ReactComponent as ReportsIcon} from "../../../statics/icons/icon_reports.svg";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import "./menu.scss";
import {routingAddresses} from "../../../helpers/routing";
import MenuItem from "./menuItem/menuItem";
import {ReactComponent as LogoUe} from "../../../statics/logos/logoUe.svg";
import {ReactComponent as LogoTps} from "../../../statics/logos/logoTps.svg";
import {ReactComponent as LogoZp} from "../../../statics/logos/logoZp.svg";
import {ReactComponent as LogoUeMini} from "../../../statics/logos/logoUeMini.svg";
import {ReactComponent as LogoTpsMini} from "../../../statics/logos/logoTpsMini.svg";
import {ReactComponent as LogoZpMini} from "../../../statics/logos/logoZpMini.svg";
import MenuSubItem from "./menuSubItem/menuSubItem";
import {RouteComponentProps, withRouter} from "react-router";
import {useTranslation} from "react-i18next";
import {storesContext} from "../../stores/stores";
import {observer} from "mobx-react";

function Menu(props: RouteComponentProps): JSX.Element {
    const {t} = useTranslation();
    const userStore = useContext(storesContext).userStore;
    const [openMenu, setOpenMenu] = React.useState("");
    const allMenus = {
        topology: routingAddresses.topology.routes.routes.split("/")[1],
        place: routingAddresses.place.ownedVehicles.list.split("/")[1],
        timetable: routingAddresses.timetable.week.split("/")[1],
        order: `${routingAddresses.order.list.split("/")[1]}/${routingAddresses.order.list.split("/")[2]}`,
        ticket: `${routingAddresses.ticket.list.split("/")[1]}/${routingAddresses.ticket.list.split("/")[2]}`,
        administration: routingAddresses.administration.users.split("/")[1],
        documents: routingAddresses.documents.generalDeclaration.generalDeclaration.split("/")[1],
        reports: routingAddresses.reports.transportRegister.split("/")[1],
        dictionaries: routingAddresses.dictionaries.ferries.ferries.split("/")[1],
        alerts: routingAddresses.alerts.list.split("/")[1],
        priceList: routingAddresses.priceList.list.split("/")[1]
    };
    const displayPlaceMenu = userStore.displayOwnedVehicles || userStore.displayParkings || userStore.displayLightBoards || userStore.displayEntryExit;

    openAtStart();

    return (
        <div className="menu">
            <div className="logos">
                <LogoTps className="logo logo-desktop"/>
                <LogoTpsMini className="logo logo-mobile"/>
                <LogoZp className="logo logo-desktop"/>
                <LogoZpMini className="logo logo-mobile"/>
            </div>

            <div className="navigation">
                {renderMenuBasedOnRoles()}
            </div>
            <div className="bottom-logo">
                <LogoUe className="logo-desktop"/>
                <LogoUeMini className="logo-mobile"/>
            </div>
        </div>
    );

    function renderMenuBasedOnRoles() {
        return (
            <>
                {userStore.displayTopology && renderTopologyMenu()}
                {displayPlaceMenu && renderPlaceMenu()}
                {userStore.displayTimetable && renderTimetableMenu()}
                {userStore.displayOrder && renderOrderMenu()}
                {userStore.displayTicket && renderTicketMenu()}
                {userStore.displayUsersList && renderAdministrationMenu()}
                {userStore.displayDocuments && renderDocumentsMenu()}
                {userStore.displayReports && renderReportsMenu()}
                {userStore.displayDictionaries && renderDictionariesMenu()}
                {userStore.displayAlerts && renderAlertsMenu()}
                {userStore.displayPriceList && renderPriceListMenu()}
            </>
        );
    }

    function renderDictionariesMenu() {
        const menu = "dictionaries";

        return (
            <MenuItem
                routingAddress={routingAddresses.dictionaries.ferries.list}
                title={t(`${menu}.title`)}
                icon={<DictionariesIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            >
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.ferries.list}
                    subTitle={t("dictionaries.ferries.title")}
                    testId="ferries-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.ports.list}
                    subTitle={t("dictionaries.ports.title")}
                    testId="ports-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.companies.list}
                    subTitle={t("dictionaries.companies.title")}
                    testId="companies-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.shipowners.list}
                    subTitle={t("dictionaries.shipowners.title")}
                    testId={"shipowners-menu"}/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.unCodes.list}
                    subTitle={t("dictionaries.unCodes.title")}
                    testId="un-codes-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.ownedVehicles.list}
                    subTitle={t("dictionaries.ownedVehicles.title")}
                    testId={"owned-vehicles-menu"}/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.dictionaries.packing.list}
                    subTitle={t("dictionaries.packing.title")}
                    testId={"packing-menu"}/>
            </MenuItem>
        );
    }

    function renderTimetableMenu() {
        const menu = "timetable";

        return (
            <MenuItem
                routingAddress={routingAddresses.timetable.week}
                title={t(`${menu}.title`)}
                icon={<CalendarIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }

    function renderAdministrationMenu() {
        const menu = "administration";

        return (
            <MenuItem
                routingAddress={routingAddresses.administration.list}
                title={t(`${menu}.title`)}
                icon={<AdministrateIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }

    function renderTicketMenu() {
        const menu = "ticket";

        return (
            <MenuItem
                routingAddress={routingAddresses.ticket.list}
                title={t("transportation.ticket.title")}
                icon={<TicketIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }

    function renderOrderMenu() {
        const menu = "order";

        return (
            <MenuItem
                routingAddress={routingAddresses.order.list}
                title={t("transportation.order.title")}
                icon={<OrderIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }

    function renderTopologyMenu() {
        const menu = "topology";

        return (
            <MenuItem
                routingAddress={routingAddresses.topology.routes.list}
                title={t(`${menu}.title`)}
                icon={<TopologyIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            >
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.topology.routes.list}
                    subTitle={t("topology.routes.title")}
                    testId="routes-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.topology.locations.list}
                    subTitle={t("topology.locations.title")}
                    testId="locations-menu"
                />
            </MenuItem>
        );
    }

    function renderDocumentsMenu() {
        const menu = "documents";

        return (
            <MenuItem
                routingAddress={routingAddresses.documents.generalDeclaration.list}
                title={t(`${menu}.title`)}
                icon={<DocumentsIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            >
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.documents.generalDeclaration.list}
                    subTitle={t("documents.generalDeclaration.title")}
                    testId="general-declaration-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.documents.manifests.list}
                    subTitle={t("documents.manifests.title")}
                    testId="manifests-menu"/>
            </MenuItem>
        );
    }

    function renderAlertsMenu() {
        const menu = "alerts";

        return (
            <MenuItem
                routingAddress={routingAddresses.alerts.list}
                title={t(`${menu}.title`)}
                icon={<AlertsIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }

    function renderPlaceMenu() {
        const menu = "place";

        return (
            <MenuItem
                routingAddress={getFirstPlaceSubmenu()}
                title={t(`${menu}.title`)}
                icon={<LocationIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            >
                {userStore.displayOwnedVehicles && (
                    <MenuSubItem
                        routingAddressSubItem={routingAddresses.place.ownedVehicles.list}
                        subTitle={t("place.ownedVehicles.title")}
                        testId="owned-vehicles-list-menu"/>
                )}
                {userStore.displayParkings && (
                    <>
                        <MenuSubItem
                            routingAddressSubItem={routingAddresses.place.ferryOrdersParkings.list}
                            subTitle={t("place.ferryOrdersParkings.title")}
                            testId="ferry-orders-parking-list-menu"/>
                        <MenuSubItem
                            routingAddressSubItem={routingAddresses.place.nonFerryOrdersParkings.list}
                            subTitle={t("place.nonFerryOrdersParkings.title")}
                            testId="non-ferry-orders-parking-list-menu"/>
                    </>
                )}
                {userStore.displayLightBoards && (
                    <MenuSubItem
                        routingAddressSubItem={routingAddresses.place.lightBoards.list}
                        subTitle={t("place.lightBoards.title")}
                        testId="light-board-list-menu"/>
                )}
                {userStore.displayEntryExit && (
                    <MenuSubItem
                        routingAddressSubItem={routingAddresses.place.entryOrExit.list}
                        subTitle={t("place.entryOrExit.title")}
                        testId="entry-or-exit-list-menu"/>
                )}
            </MenuItem>
        );
    }

    function renderReportsMenu() {
        const menu = "reports";

        return (
            <MenuItem
                routingAddress={routingAddresses.reports.listOfShipments}
                title={t(`${menu}.title`)}
                icon={<ReportsIcon/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            >
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.listOfShipments}
                    subTitle={t("reports.listOfShipments.title")}
                    testId="list-of-shipments-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.transportRegister}
                    subTitle={t("reports.transportRegister.title")}
                    testId="transport-register-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.ferryHandlingTime}
                    subTitle={t("reports.ferryHandlingTime.title")}
                    testId="ferry-handling-time-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.vehicleOrCargoHandlingTime}
                    subTitle={t("reports.vehicleOrCargoHandlingTime.title")}
                    testId="vehicle-or-cargo-handling-time-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.trailerBase}
                    subTitle={t("reports.trailerBase.title")}
                    testId="trailer-base-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.dangerousGoodsRegister}
                    subTitle={t("reports.dangerousGoodsRegister.title")}
                    testId="dangerous-goods-register-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.seaFerriesSummary}
                    subTitle={t("reports.seaFerriesSummary.title")}
                    testId="sea-ferries-summary-menu"/>
                <MenuSubItem
                    routingAddressSubItem={routingAddresses.reports.invoiceAttachment}
                    subTitle={t("reports.invoiceAttachment.title")}
                    testId="invoice-attachment-menu"/>
            </MenuItem>
        );
    }

    function renderPriceListMenu() {
        const menu = "priceList";

        return (
            <MenuItem
                routingAddress={routingAddresses.priceList.list}
                title={t(`${menu}.title`)}
                icon={<LocalOfferIcon fontSize="small" className="price-list-icon"/>}
                testId={`${menu}-menu`}
                isOpen={isOpen(menu)}
                handleOpenSubItem={() => {
                    setOpenMenu(menu);
                }}
                history={props.history}
            />
        );
    }


    function openAtStart() {
        for (const key in allMenus) {
            // @ts-ignore
            if (props.location.pathname.includes(allMenus[key]) && openMenu !== key) {
                setOpenMenu(key);
            }
        }
    }

    function isOpen(menu: string) {
        return openMenu === menu;
    }

    function getFirstPlaceSubmenu() {
        if (userStore.displayOwnedVehicles) return routingAddresses.place.ownedVehicles.list;
        else if (userStore.displayParkings) return routingAddresses.place.ferryOrdersParkings.list;
        else if (userStore.displayLightBoards) return routingAddresses.place.lightBoards.list;
        else return routingAddresses.place.entryOrExit.list;
    }
}

export default withRouter(observer(Menu));
